import {create} from "zustand";

type FiltersState = {
  filters: Record<string, any>;
};

type FiltersActions = {
  setFilters: (filters: Record<string, any>) => void;
  clearFilters: () => void;
};

type FiltersStore = FiltersState & FiltersActions;

export const useFiltersStore = create<FiltersStore>((set) => ({
  filters: {},

  clearFilters: () => {
    set({filters: {}});
  },
  setFilters: (filters: Record<string, any>) => {
    set(() => ({
      filters,
    }));
  },
}));

export function useStoredFilters<T extends Record<string, any>>() {
  return useFiltersStore((state) => state.filters) as T;
}

export function useStoredSetFilters<T extends Record<string, any>>() {
  return useFiltersStore((state) => state.setFilters) as (filters: T) => void;
}

export function useStoredClearFilters() {
  return useFiltersStore((state) => state.clearFilters) as () => void;
}
